import logoSE from '../assets/img/se.jpg';
import logoDK from '../assets/img/dk.jpg';
import logoFI from '../assets/img/fi.jpg';
import logoNO from '../assets/img/no.jpg';
export var Countries;
(function (Countries) {
    Countries["SE"] = "SE";
    Countries["DK"] = "DK";
    Countries["NO"] = "NO";
    Countries["FI"] = "FI";
})(Countries || (Countries = {}));
export const getCountryFlag = countryCode => {
    switch (countryCode) {
        case Countries.SE:
            return logoSE;
        case Countries.DK:
            return logoDK;
        case Countries.FI:
            return logoFI;
        case Countries.NO:
            return logoNO;
        default:
            return null;
    }
};
export const getCountryIds = () => {
    const countryIds = [];
    Object.keys(Countries).forEach(countryId => {
        countryIds.push(Countries[countryId]);
        return null;
    });
    return countryIds;
};
export class CountryLabels {
    constructor() {
        this.labels = {};
        // this.labels[Countries.SE] = getText('countries.sweden')
        // this.labels[Countries.DK] = getText('countries.denmark')
        // this.labels[Countries.NO] = getText('countries.norway')
        // this.labels[Countries.FI] = getText('countries.finland')
    }
}
export const getCountryNames = () => {
    const countryNames = [];
    const countryLabels = new CountryLabels();
    Object.keys(Countries).forEach(countryId => {
        countryNames.push(countryLabels.labels[countryId]);
        return null;
    });
    return countryNames;
};
export const getCountryName = id => {
    const countryIds = Object.keys(Countries);
    const countryLabels = new CountryLabels();
    for (let i = 0; i < countryIds.length; i += 1) {
        if (countryIds[i] === id) {
            return countryLabels.labels[countryIds[i]];
        }
    }
    return null;
};
export class CurrencySymbol {
    constructor({ prefix = '', suffix = '' }) {
        this.prefix = prefix;
        this.suffix = suffix;
    }
    wrap(value) {
        return [this.prefix, value, this.suffix].filter(v => !!v).join(' ');
    }
    wrapRange(from, to) {
        return this.wrap(`${from}–${to}`);
    }
    toString() {
        return this.prefix || this.suffix;
    }
}
export const getCurrencySymbol = country => {
    switch (country) {
        case Countries.FI:
            return new CurrencySymbol({ suffix: '€' });
        case Countries.DK:
            return new CurrencySymbol({ suffix: 'kr.' });
        case Countries.SE:
        case Countries.NO:
        default:
            return new CurrencySymbol({ suffix: 'kr' });
    }
};
export const getDefaultVatRate = country => {
    switch (country) {
        case Countries.FI:
            return 0.24;
        case Countries.SE:
        case Countries.DK:
        case Countries.NO:
        default:
            return 0.25;
    }
};
export const getEIDProviderName = country => {
    switch (country) {
        case Countries.FI:
            return 'Tupas';
        case Countries.DK:
            return 'NemID';
        case Countries.SE:
            return 'BankID';
        case Countries.NO:
            return 'BankID';
        default:
            return 'BankID';
    }
};
export const isEIDLinkRequired = country => {
    switch (country) {
        case Countries.FI:
        case Countries.DK:
            return true;
        case Countries.SE:
        case Countries.NO:
        default:
            return false;
    }
};
